import { useState, type FormEvent } from "react";
import { KeyRound, LoaderCircle, LockKeyhole } from "lucide-react";
import { Navigate, useNavigate } from "react-router-dom";
import { api, auth } from "../lib/api";
import { displayError } from "../lib/format";

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (auth.isAuthenticated()) return <Navigate to="/" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.login(username.trim(), password);
      navigate("/", { replace: true });
    } catch (caught) {
      setError(displayError(caught));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-brand">
          <span className="brand-mark brand-mark-large">HF</span>
          <div>
            <strong>Higgsfield2API</strong>
            <span>Operations Console</span>
          </div>
        </div>
        <div className="login-heading">
          <LockKeyhole size={22} />
          <h1>管理员登录</h1>
        </div>
        <form onSubmit={submit}>
          <label className="field">
            <span>用户名</span>
            <input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" required autoFocus />
          </label>
          <label className="field">
            <span>密码</span>
            <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required />
          </label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button button-primary button-block" type="submit" disabled={busy}>
            {busy ? <LoaderCircle className="spin" size={17} /> : <KeyRound size={17} />}
            登录
          </button>
        </form>
      </section>
      <footer className="login-footer">受保护的管理入口</footer>
    </main>
  );
}
